import { motion } from 'framer-motion'

const Footer = () => {
  return (
    <footer className="bg-ds-navy py-12 sm:py-16 lg:py-20">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-20 items-start">
          {/* Left side - Logo */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="footer-logo text-ds-off-white/50 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl">
              DAILY STRIDE LLC .
            </h2>
          </motion.div>

          {/* Right side - Description */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:text-right"
          >
            <p className="font-body text-xs sm:text-sm lg:text-base text-ds-off-white/50 leading-relaxed max-w-md lg:ml-auto text-start">
              Daily Stride LLC develops and manages proprietary digital 
              applications in accordance with applicable laws and 
              platform guidelines.
            </p>
          </motion.div>
        </div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex flex-col lg:flex-row justify-between items-center gap-8 mt-6 sm:mt-8 lg:mt-12 text-ds-off-white"
        >
          <p className="font-body text-sm lg:text-md text-ds-off-white">
            © 2026 Daily Stride LLC. All rights reserved.
          </p>
          <hr className='w-4/6 h-3 text-ds-off-white md:mt-2'/>
        </motion.div>
      </div>
    </footer>
  )
}

export default Footer
